import { makeStyles } from '@material-ui/core';
var multiChoiceGroupStyles = makeStyles(function (theme) { return ({
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        marginRight: 2,
    },
}); });
export default multiChoiceGroupStyles;
//# sourceMappingURL=styles.js.map